const ActionWarehouseTypes = {
  ADD_WAREHOUSE: "ADD_WAREHOUSE",
  DELETE_WAREHOUSE: "DELETE_WAREHOUSE",
  EDIT_WAREHOUSE: "EDIT_WAREHOUSE",
  GET_WAREHOUSLIST: "GET_WAREHOUSLIST",
};
export default ActionWarehouseTypes;
